export default "__VITE_PUBLIC_ASSET__75c2daf5__"